<template>
  <div
    v-if="stepData.travellingPeople"
    class="form-section"
  >
    <div
      v-for="item in amountOfQuestionsToRender"
      :key="item"
    >
      <question-base-wrapper
        :id="`${questionId}_${item}`"
        v-bind="baseWrapperProps"
        :class="additionalClasses"
        :title="getIterableTitle(item + 1)"
      >
        <validation-provider
          :vid="`${stepId}_${questionId}_${item}`"
          :name="`${questionId}_${item}`"
          :rules="dateValidationRules"
        >
          <qz-date-select
            v-model="travellers[item - 1].dateOfBirth"
            :form-observer="formObserver"
            :data-test="snakeCase(questionFields.field)"
            :vid="`${stepId}_${questionId}_${item}`"
            :year-options="getYearsOptions"
            :date-rule="dateValidationRules"
          />
        </validation-provider>
      </question-base-wrapper>
    </div>
  </div>
</template>

<script>
import BaseDate from './BaseDate';
import { toWordsOrdinal } from 'number-to-words';

export default {
  name: 'question-date-of-birth-group',
  extends: BaseDate,
  props: {
    isVerticalSplitted: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      travellers: [],
    };
  },
  computed: {
    getAmountOfTravellers () {
      return this.stepData.travellingPeople;
    },
    amountOfQuestionsToRender () {
      return this.getAmountOfTravellers - 1;
    },
    additionalClasses () {
      return {
        vertically: this.isVerticalSplitted,
      };
    },
  },
  watch: {
    travellers: {
      handler (val) {
        this.stepData.dateOfBirthGroup = {
          adults: val.map(traveller => traveller.dateOfBirth),
        };
      },
      deep: true,
    },
    getAmountOfTravellers (newVal, old) {
      if (old === newVal) return;

      if (old === null) {
        // because travellingPeople === mainTraveller + group amount
        this.addItemsToDob(newVal - 1);
      } else {
        this.updateDobValue(newVal, old);
      }
    },
  },
  created () {
    if (this.stepData.dateOfBirthGroup) this.initDefaultValue();
  },
  methods: {
    updateDobValue (newVal, old) {
      const newIsBigger = newVal > old;
      const amountDifference = newIsBigger ? newVal - old : old - newVal;

      if (newIsBigger) {
        // because travellingPeople === mainTraveller + croup amount
        this.addItemsToDob(amountDifference);
      } else {
        this.travellers.splice(-amountDifference);
      }
    },
    initDefaultValue () {
      for (const [key, value] of Object.entries(this.stepData.dateOfBirthGroup)) {
        if (key !== 'adults') continue;
        value.forEach(dateOfBirth => {
          this.travellers.push({
            dateOfBirth,
          });
        });
      }
    },
    addItemsToDob (amount) {
      for (let i = 0; i < amount; i++) {
        this.travellers.push({
          dateOfBirth: '',
        });
      }
    },
    getIterableTitle (n) {
      const modifiedTitle = this.title.split(' ');
      modifiedTitle.splice(2, 0, `${toWordsOrdinal(n)}`);

      return modifiedTitle.join(' ');
    },
  },
};
</script>

<style lang="scss" scoped src="@/assets/scss/shared/vertical-row.scss"/>
